<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 检索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="  联系方式">
                <a-input v-model="queryParam.phone" placeholder="手机号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号">
                <a-input v-model="queryParam.orderNo" placeholder="订单号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select v-model="queryParam.status" placeholder="全部" allow-clear>
                  <a-select-option :value="1">冻结</a-select-option>
                  <a-select-option :value="2">已使用</a-select-option>
                  <a-select-option :value="3">已返还</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 表格 -->
      <a-table
        :loading="loading"
        rowKey="userId"
        :columns="columns"
        :data-source="list"
        :pagination="{
          current: queryParam.pageNum,
          pageSize: queryParam.pageSize,
          total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 条`,
        }"
        @change="changeSize"
      >
        <span slot="totalSaveAmount" slot-scope="text"> ¥{{ text.toFixed(2) }} </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getUserCouponStatList } from '@/api/coupon/controller/userCouponStat'

export default {
  name: 'UserCouponStat',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,

      },
      columns: [

        { title: '用户名称', dataIndex: 'userName', width: 160, align: 'center' },
        { title: '联系方式', dataIndex: 'phone', align: 'center' },
        { title: '订单号', dataIndex: 'orderNo', align: 'center', ellipsis: true },
        { title: '金额', dataIndex: 'amount', align: 'center', customRender: (text) => `¥${text}` },
        {
          title: '使用状态',
          dataIndex: 'status',

          align: 'center',
          customRender: (text) => ({ 1: '冻结', 2: '已使用', 3: '已返还' }[text] || '-'),
        },
        { title: '使用时间', dataIndex: 'useTime', align: 'center', customRender: (text) => text || '-' },
        { title: '插入时间', dataIndex: 'createTime', align: 'center' },

      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getUserCouponStatList(this.queryParam)
        .then((res) => {
          this.list = res.data.records
          this.total = res.data.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,

      }
      this.handleQuery()
    },
    changeSize(pagination) {
      this.queryParam.pageNum = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.getList()
    },
  },
}
</script>
